import { IApplicationState } from '../../types/redux';

export const getQuestionById = (id: string) => (state: IApplicationState) => {
  return state.questions.byId[id];
};
